import { NO_SCENE_KEY } from '../constants';

export const key2SceneName = (key: string): string => (key === NO_SCENE_KEY ? null : key);
